const brl = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });

/** R$ 1.234,56 — aceita número ou texto numérico; vazio vira "—". */
export function formatBRL(valor) {
  const n = toNumber(valor);
  return n == null ? "—" : brl.format(n);
}

/** Converte número/texto ("149,90" ou "149.90") em número, ou null. */
export function toNumber(valor) {
  if (valor === "" || valor == null) return null;
  const n = typeof valor === "number" ? valor : Number(String(valor).replace(",", "."));
  return Number.isFinite(n) ? n : null;
}

/** Timestamp do Firestore, Date, número ou texto → Date (ou null). */
export function toDate(valor) {
  if (!valor) return null;
  if (typeof valor.toDate === "function") return valor.toDate();
  if (typeof valor.seconds === "number") return new Date(valor.seconds * 1000);
  const d = valor instanceof Date ? valor : new Date(valor);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatDateTime(valor) {
  const d = toDate(valor);
  return d
    ? d.toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" })
    : "—";
}

/**
 * Datas de jogo são texto. O painel grava "aaaa-MM-dd" (input date) e
 * registros antigos usam "dd/MM/aaaa"; aqui as duas viram "aaaa-MM-dd".
 */
export function isoDate(texto) {
  if (!texto) return "";
  const s = String(texto).trim();
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
  const m = s.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  return m ? `${m[3]}-${m[2]}-${m[1]}` : "";
}

/** "aaaa-MM-dd" ou "dd/MM/aaaa" → "dd/MM/aaaa". */
export function formatGameDate(texto) {
  const iso = isoDate(texto);
  if (!iso) return texto || "—";
  const [y, m, d] = iso.split("-");
  return `${d}/${m}/${y}`;
}

/** Hoje em "aaaa-MM-dd" no fuso local. */
export function todayIso() {
  const n = new Date();
  const p = (x) => String(x).padStart(2, "0");
  return `${n.getFullYear()}-${p(n.getMonth() + 1)}-${p(n.getDate())}`;
}

export const initials = (nome = "") =>
  nome
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? "")
    .join("") || "?";

export const plural = (n, um, varios) => `${n} ${n === 1 ? um : varios}`;

/** Busca sem acento e sem diferenciar maiúsculas. */
export function normalize(texto = "") {
  return String(texto)
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase();
}

export const matches = (busca, ...campos) => {
  const q = normalize(busca.trim());
  return !q || campos.some((c) => normalize(c).includes(q));
};

/** Mensagem legível de erro do Firebase/Functions. */
export function errorMessage(err, fallback = "Algo deu errado. Tente novamente.") {
  if (!err) return fallback;
  if (err.code === "permission-denied" || err.code === "functions/permission-denied")
    return "Sem permissão para esta ação.";
  if (err.code === "unavailable") return "Sem conexão com o servidor.";
  return err.message?.replace(/^(Firebase(Error)?|FirebaseError):\s*/i, "") || fallback;
}

/**
 * IDs de documento iguais aos que o app calcula (game_details_tab.dart e
 * confrontos_tab.dart): sem acento e com "_" no lugar de espaços.
 */
const semAcento = (t) => String(t).trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
export const idEstadio = (nome) => semAcento(nome).replace(/ /g, "_");
export const idConfronto = (adversario) => semAcento(adversario).toLowerCase().replace(/ /g, "_");
